/**
 * Сколько медиа-элементов сейчас играет в приложении (видео или голосовое).
 *
 * Нужно, чтобы звук входящего сообщения не прерывал просмотр: он проигрывается
 * через react-native-sound с категорией Playback, забирает аудиофокус, и плеер
 * видео сам ставит себя на паузу — «при просмотре переданного видео, если
 * параллельно пришло сообщение, видео встаёт на паузу» (стори 5.4).
 *
 * Счётчик, а не флаг: одновременно могут играть, например, видео в чате и
 * голосовое в другом бабле, и остановка одного не должна снимать «занятость».
 */
let activeCount = 0;

export function markMediaPlaybackStarted(): void {
  activeCount += 1;
}

export function markMediaPlaybackStopped(): void {
  activeCount = Math.max(0, activeCount - 1);
}

export function isMediaPlaybackActive(): boolean {
  return activeCount > 0;
}

/** Только для тестов. */
export function resetMediaPlaybackFocus(): void {
  activeCount = 0;
}
